// @ts-nocheck
import { getContentSearch, GetContentSearchApiParameter } from "@store/Framework/Services/ContentSearchService";
import { ContentSearchPagesCollectionModel } from "@store/Framework/Types/ApiModels";
import { ApiHandler, createHandlerChainRunner } from "@toolkit/Modules/client-framework/HandlerCreator";
import { getContextData } from "@toolkit/Modules/client-framework/Store/Data/Pages/PagesActionCreators";

type HandlerType = ApiHandler<GetContentSearchApiParameter, ContentSearchPagesCollectionModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const DispatchBeginLoadContentSearchResults: HandlerType = props => {
    props.dispatch({
        type: "Data/Pages/BeginLoadPages",
        parameter: props.apiParameter as any,
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getContentSearch(props.apiParameter);
};

export const DispatchCompleteLoadContentSearchResults: HandlerType = props => {
    const state = props.getState();
    const { pages, pagination } = props.apiResult;

    props.dispatch({
        type: "Data/Pages/CompleteLoadPages",
        parameter: props.apiParameter as any,
        collection: {
            pages,
            pagination: pagination as any,
        },
        links: state.links,
        ...getContextData(state),
    });
};

export const chain = [
    PopulateApiParameter,
    DispatchBeginLoadContentSearchResults,
    RequestDataFromApi,
    DispatchCompleteLoadContentSearchResults,
];

const loadContentSearchResults = createHandlerChainRunner(chain, "LoadContentSearchResults");
export default loadContentSearchResults;
